(function () {
'use strict';
document.documentElement.classList.add('lm-js');
var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
function initReveal(root) {
var els = root.querySelectorAll('[data-lm-reveal]:not(.is-in)');
if (reduce || !('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-in'); }); return; }
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
}, { rootMargin: '0px 0px -10% 0px' });
els.forEach(function (e) { io.observe(e); });
}
function initSticky() {
var bar = document.querySelector('[data-lm-sticky]');
if (!bar || !('IntersectionObserver' in window)) return;
var watched = document.querySelectorAll('[data-lm-cta]');
var visible = new Set();
function update() { bar.classList.toggle('is-visible', window.scrollY > 400 && visible.size === 0); }
var io = new IntersectionObserver(function (entries) {
entries.forEach(function (en) { en.isIntersecting ? visible.add(en.target) : visible.delete(en.target); });
update();
});
watched.forEach(function (w) { io.observe(w); });
window.addEventListener('scroll', update, { passive: true });
update();
}
function initSpin(root) {
root.querySelectorAll('[data-lm-spin]:not([data-ready])').forEach(function (el) {
el.setAttribute('data-ready', '');
var row = el.querySelector('.lm-spin__row'), img = el.querySelector('.lm-spin__img');
var cols = 10, rows = 6, n = 60, frame = 0, startX = 0, startF = 0, down = false;
function show(f) { frame = ((f % n) + n) % n; img.style.transform = 'translateX(' + (-(frame % cols) * 100 / cols) + '%)'; row.style.transform = 'translateY(' + (-Math.floor(frame / cols) * 100 / rows) + '%)'; }
el.addEventListener('pointerdown', function (e) {
if (!el.classList.contains('is-manual')) { frame = Math.floor(((performance.now() / 1000) % 6) / 6 * n); el.classList.add('is-manual', 'is-touched'); }
down = true; startX = e.clientX; startF = frame; show(frame);
try { el.setPointerCapture(e.pointerId); } catch (err) {}
});
el.addEventListener('pointermove', function (e) { if (down) show(startF + Math.round((e.clientX - startX) / (el.clientWidth / 30))); });
el.addEventListener('pointerup', function () { down = false; });
el.addEventListener('pointercancel', function () { down = false; });
});
}
function initAll(root) { initReveal(root); initSpin(root); }
document.addEventListener('DOMContentLoaded', function () { initAll(document); initSticky(); });
document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
